import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { RefactoringCompletionsComponent } from './refactoring-completions/refactoring-completions.component';
import { NotifyAssociation, ManageAssociationComponent } from './manage-association/manage-association.component';
import { ManageDocumentComponent } from './manage-document/manage-document.component';
import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
  Input,
  EventEmitter,
  Output
} from '@angular/core';
import { Logger } from '@app/core';
import {
  Actividad,
  BaseControl,
  ConfirmComponent,
  DynamicFormComponent,
  Microproceso,
  Static,
  Tarea,
  Tramite,
  Const,
  TareaTipo,
  TareaCondicionAdmin,
  TramiteBase,
  TareaAsociacionPred,
  TypeProcess,
  ProcesoSecundario,
  FormaListasChequeo
} from '@app/shared';
import { find, isEmpty, merge, result, findIndex } from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs/Subscription';
import { Action, ConfigShowItems, EventAction } from './btn-trigger';
import { ManageConditionsComponent } from './manage-conditions/manage-conditions.component';
import { NotifyCompletion } from './manage-completion/manage-completion.component';
import {
  CptFormService,
  ProcessAutomationService,
  SelectTramiteService,
  StorageService,
  FlowType,
  FlowOrigin
} from './shared';
import { ManageActivityService } from './shared/manage-activity.service';
import { ManageTaskService } from './shared/manage-task.service';
import { ToastrService } from 'ngx-toastr';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ManageFormComponent, NotifyTareaForma } from './manage-form/manage-form.component';
import { environment } from '@env/environment';
import {
  ManageSecondaryCompletionsComponent
} from './manage-secondary-completions/manage-secondary-completions.component';
import { ManagementCheckListFormComponent } from './management-check-list-form/management-check-list-form.component';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { FlowTitle } from '@app/shared/title';
import { FlowMode, HelperFlowService } from '@app/shared/services/helper-flow.service';
import { ActivityService } from '@app/shared/activity/shared/activity.service';
import { TaskService } from '@app/shared/task/shared/task.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { Subject } from 'rxjs';

const log = new Logger('ProcessAutomationComponent');

// Objetos validos para eliminar usando la función 'removeObject'
type RemovedObject = ActivityTask | Actividad;
type RemovedObjectType = 'activity' | 'task';
// Define las acciones posibles para una tarea o actividad
type actionManage = 'create' | 'edit' | 'remove' | 'run';
// Base para los contextos de las plantillas que gestionan un trozo del componente
interface ManageContext {
  event: any;
  controls: BaseControl<any>[];
  classBtnSubmit: string | Array<string>;
  valueBtnSubmit: string;
  title: string;
  isLoading: boolean;
  extra?: any;
}
// Define el contexto de la plantilla 'cptFormTpl'
interface ManageContextCpt extends ManageContext {
  event: EventAction;
}
// Define el contexto de la plantilla 'manageActivityTpl'
interface ManageContextActivity extends ManageContext {
  event: actionManage;
}
// Define el contexto de la plantilla 'manageTaskTpl'
interface ManageContextTask extends ManageContext {
  event: actionManage;
}
interface ActivityTask extends ManageContext {
  activity: Actividad;
  task: Tarea;
}

@Component({
  selector: 'iw-process-automation',
  templateUrl: './process-automation.component.html',
  styleUrls: ['./process-automation.component.scss'],
  providers: [
    CptFormService,
    SelectTramiteService,
    HelperFlowService,
    ProcessAutomationService,
    ActivityService,
    TaskService,
    StorageService,
    ManageActivityService,
    ManageTaskService,
    DragulaService
  ]
})
export class ProcessAutomationComponent implements OnInit, OnDestroy {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess: TypeProcess;
  // Contiene el tipo de proceso que se esta renderizando
  @Input() secondaryProcess: ProcesoSecundario;
  // Componente select-tramite
  @Input() stcRef: SelectTramiteComponent;
  // Define los tipos de permisos que tiene el usuario en sesión
  @Input() activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
    duplicate: false,
  };
  // Referencia para ubicar scroll
  referenceScroll = '';
  // define cuando es una forma con condicion
  formCondiction = false;
  // define cuando es una forma con listas de chequeo
  formCheckList = false;
  // Configuración para generar el título del flujo
  configFlowTitle: Partial<FlowTitle>;
  // Configuración para generar el título del flujo
  configFlowTitleTemporalAsociation: Partial<FlowTitle>;
  // Determina si se esta trabajando con el flujo pero para asigna una tarea
  flowMode: FlowMode = 'normal';
  // Contiene el id del flujo actual
  idFlowactually = 0;
  // Contiene el tipo de tarea anterior
  typeTaskOld = -1;
  // Define si al reiniciar el flujo se reinicia con el flujo guardado (finalizaciones y asociaciones)
  flowHistoryActually = false;
  // Define cuando debe ocultar la tarea fantasma
  hiddenTaskGhost = false;
  // Determina si se esta ejecutando una petición al backend
  isLoading = {
    flow: false,
    sync: false
  };
  // Muestra diferentes elementos
  show = {
    // Actividad fantasma
    ghostActivity: 0,
    // Templates que renderizan los elementos de la vista
    firstTemplate: true,
    secondTemplate: false,
    // Botón para sicronizar el flujo
    btnSync: false,
  };
  // Determina si se esta precinando una tecla
  keyIsPressed = {
    ctrl: false
  };
  // origen del flujo
  origin: FlowOrigin;
  // Contiene la informacion de las listas de chequeo de la forma seleccionada
  formsCheckListSelected: FormaListasChequeo;
  // Contiene las configuraciones de las listas de chequeo de la forma seleccionada
  optionsFormSelect: any = {};
  // Contiene las tareas asociadas
  taskAssociation: Array<Tarea>;
  // Contexto para los datos de la plantilla cptFormTpl
  cptFormCtx: Partial<ManageContextCpt> = {};
  // Contexto para los datos de la plantilla manageActivityTpl
  manageActivityCtx: Partial<ManageContextActivity> = {};
  // Contexto para los datos de la plantilla manageTaskTpl
  manageTaskCtx: Partial<ManageContextTask> = {};
  // Plantillas encargadas de renderizar el contenido de la vista
  firstTemplate: TemplateRef<any>;
  secondTemplate: TemplateRef<any>;
  // Determina si se muestran ayudas de debug
  showDebugHelpers = environment.showDebugHelpers;
  // Emite la lista de alias configurado para las asociaciones
  listAliasAsocciations: Array<{alias: string}> = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Plantilas disponibles para renderizar en ng-container
  @ViewChild('cptFormTpl') cptFormTpl: TemplateRef<any>;
  @ViewChild('flowConfigTpl') flowConfigTpl: TemplateRef<any>;
  @ViewChild('manageActivityTpl') manageActivityTpl: TemplateRef<any>;
  @ViewChild('manageTaskTpl') manageTaskTpl: TemplateRef<any>;
  @ViewChild('flowAssociationsTpl') flowAssociationsTpl: TemplateRef<any>;
  // Referencia al formulario dinámico de crear y editar categorias, procesos y trámites
  @ViewChild('cptDyFormRef') cptDyFormRef: DynamicFormComponent;
  // Referencia al formulario dinámico de crear y editar tareas
  @ViewChild('taskDyFormRef') taskDyFormRef: DynamicFormComponent;
  // Referencia del control personalizado para el select de roles en tareas
  @ViewChild('selectRolesTpl') selectRolesTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select para los formularios o maestras
  @ViewChild('ngSelectFormulario') ngSelectFormulario: TemplateRef<any>;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) confirmRef: ConfirmComponent;
  // Referencia al componente que controlas las tabs de tareas
  @ViewChild('taskTabs') taskTabs: TabsetComponent;
  // Componente que gestiona las condiciones de la tarea
  @ViewChild(ManageConditionsComponent) manageConditionsRef: ManageConditionsComponent;
  // Referencia al tab de documentos
  @ViewChild(ManageDocumentComponent) manageDocumentRef: ManageDocumentComponent;
  // Referencia al tab de asociaciones
  @ViewChild(ManageAssociationComponent) manageAssociationsRef: ManageAssociationComponent;
  // Componente que gestiona las finalizacion de la tarea
  @ViewChild(RefactoringCompletionsComponent) manageCompletionRef: RefactoringCompletionsComponent;
  // Componente que gestiona las finalizacion de las secundarias
  @ViewChild(ManageSecondaryCompletionsComponent) completiosSecondary: ManageSecondaryCompletionsComponent;
  // Componente que gestiona las condiciones de la tarea
  @ViewChild(ManageFormComponent) manageFormRef: ManageFormComponent;
  // Componente de configuracion de listas de chequeo
  @ViewChild(ManagementCheckListFormComponent) manageChecklistFormRef: ManagementCheckListFormComponent;
  // Emite e evento para refrescar las secundarias
  @Output() reloadSeconary: EventEmitter<number> = new EventEmitter();
  // Suscripción a las notificaciones de otros componentes
  private notifications: Subscription;
  // Variable temporal que contien datos suceptibles
  // a perdidas en diferentes acciones
  private dataBackup: { [key: string]: any } = {};
  // Id temporal de un administrador de finalizaciones
  private manageCompletionId: string;
  // Contador de creacion de las actividades seguidas
  private counterCreationActivities = 0;
  public formRestrition: boolean = false;
  public listRestrition: any[] = [];

  constructor(
    public hfs: HelperFlowService,
    public ss: StorageService,
    public mas: ManageActivityService,
    public mts: ManageTaskService,
    private ds: DragulaService,
    private cptfs: CptFormService,
    private sts: SelectTramiteService,
    private ns: NotifierService,
    private pas: ProcessAutomationService,
    private toastr: ToastrService,
    private scroll: ScrollToService
  ) {
    // Vigila el evento de arrastrar la tarea
    ds.drag.subscribe((value: any[]) => {
      this.hiddenTaskGhost = true;
    });
    // Vigilar el cambio del modelo de la bolsa
    ds.dropModel.subscribe((value: any[]) => {
      this.onDropModel(value);
      this.hiddenTaskGhost = false;
    });
    // Vigila el evento de soltar de Dragula
    ds.out.subscribe((value: any[]) => {
      this.hiddenTaskGhost = false;
    });
    if (this.ds.find('bag-activities')){
      this.ds.destroy('bag-activities');
    }
    if (this.ds.find('bag-tasks')){
      this.ds.destroy('bag-tasks');
    }
    // Configuraciones para la bolsa de actividades (dragula)
    ds.setOptions('bag-activities', {
      moves: (el: any, container: any, handle: any) => {
        const hasClass = Static.nativeElementHasClass(handle, 'drag-activity');
        return hasClass;
      }
    });
    // Configuraciones para la bolsa de tareas (dragula)
    // Pendiente arreglar el arrastrar de tareas
    ds.setOptions('bag-tasks', {
      moves: (el: any, container: any, handle: any) => {
        const hasClass = Static.nativeElementHasClass(handle, 'drag-task');
        if (this.flowMode === 'normal') {
          return hasClass;
        } else {
          return false;
        }
      }
    });
  }

  ngOnInit() {
    this.referenceScroll = '';
    this.ss.typeProcess = this.typeProcess;
    // Escuchar todas las notificaciones de los elementos hijos del flujo
    this.notifications = this.ns.get().subscribe(n => {
      if (n.instance === this.typeProcess) {
        // define si la accion se puede realizar por los permisos del usuario
        let actAction = false;
        // Define si se ejecuta el evento solicitado
        let next = this.flowMode === 'normal' ? true : false;
        // Si se ejecutó el evento click en una tarea
        if (n.source === 'task') {
          let action: actionManage;
          // Definir la acción que se quiere hacer con la tarea
          switch (n.action) {
            case 'newTask':
              if (this.activateAction.created) {
                action = 'create';
                actAction = true;
              }
              break;
            case 'editTask':
              if (this.activateAction.update) {
                action = 'edit';
                next = true;
                actAction = true;
              }
              break;
            case 'removeTask':
              if (this.activateAction.delete) {
                action = 'remove';
                actAction = true;
              }
              break;
            case 'runMicroProcess':
              action = 'run';
              next = true;
              actAction = true;
              break;
          }


          this.referenceScroll = 'actividad_' + n.data.task.tarea_actividad + 'tarea_' + n.data.task.orden;

          // Controla la acción requerida de la actividad
          if (next && actAction) {
            this.initManageTask(action, n.data);
          }
        }
        // Si se ejecutó el evento en una actividad
        if (n.source === 'activity') {
          let action: actionManage;
          let skipManageActivity = false;
          // Definir la acción que se quiere hacer con la actividad
          switch (n.action) {
            case 'newActivity':
              if (this.activateAction.created) {
                action = 'create';
                actAction = true;
              }
              break;
            case 'editActivity':
              if (this.activateAction.update) {
                action = 'edit';
                actAction = true;
              }
              break;
            case 'removeActivity':
              if (this.activateAction.delete) {
                action = 'remove';
                actAction = true;
              }
              break;
            case 'newTask':
              if (this.activateAction.created) {
                action = 'create';
                skipManageActivity = true;
                if (next) {
                  this.initManageTask(action, n.data);
                }
                actAction = true;
              }
              break;
          }

          if (n.data && n.data.activity) {
            this.referenceScroll = 'actividad_' + n.data.activity.orden;
          }
          // Controla la acción requerida de la actividad
          if ((next && !skipManageActivity) && actAction) {
            this.initManageActivity(action, n.data);
          }
        }
        // Si se debe activar el modo de finalización (flujo)
        if (n.source === 'manageCompletion' && n.action === 'activeCompletionMode') {
          const data = <NotifyCompletion>n.data;
          this.manageCompletionId = data.id;
          this.idFlowactually = this.ss.flow.id;
          this.hfs.saveFlow();
          this.flowHistoryActually = true;
          this.toggleCompletionMode(true);
        }
        // notificacion del componente de asociaciones para activar el flujo
        if (n.source === 'manageAssociation' && n.action === 'activeAssociationMode') {
          const data = <NotifyAssociation>n.data;
          this.manageCompletionId = data.id;
          this.taskAssociation = data.targetTask;
          this.idFlowactually = this.ss.flow.id;
          this.hfs.saveFlow();
          this.flowHistoryActually = true;
          this.toggleCompletionMode(true, 'association');
        }
      }
    });
  }

  ngOnDestroy() {
    this.notifications.unsubscribe();
    if (this.ds.find('bag-activities')){
      this.ds.destroy('bag-activities');
    }
    if (this.ds.find('bag-tasks')){
      this.ds.destroy('bag-tasks');
    }
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Cierra el una plantilla y si hay un flujo activo lo muestra.
   *
   * @memberof ProcessAutomationComponent
   */
  closeTpl(tpl?: TemplateRef<any>) {
    if (this.flowMode === 'normal') {
      this.manageActivityCtx = {};
      this.manageTaskCtx = {};
      this.cptFormCtx = {};
      this.formCondiction = false;
      this.formCheckList = false;
      this.show.btnSync = true;
      if (tpl) {
        this.firstTemplate = tpl;
      } else {
        if (this.ss.flow) {
          this.firstTemplate = this.flowConfigTpl;
        } else {
          this.firstTemplate = null;
          this.show.btnSync = false;
        }
      }

      setTimeout(() => {
        this.scroll.scrollTo({
          target: this.referenceScroll
        } as ScrollToConfigOptions);

        this.referenceScroll = '';
      });


    }
    // se reinicia el contador de creacion de actividades
    this.counterCreationActivities = 0;
  }

  /**
   * Retrocede un nivel en el flujo.
   *
   * @memberof ProcessAutomationComponent
   */
  goBack() {
    this.hfs.returnToPreviousFlow(
      // Trámite
      idTramite => this.selectedDefaultTramite(idTramite, 'tramiteInGoBack', true),
      // Microproceso
      idMicroProcess => this.runMicroProcess(idMicroProcess, true)
    );
  }

  /**
   * Vuelve al flujo actual guardado
   * Solo funciona para las asociaciones y finalizaciones
   *
   * @memberof ProcessAutomationComponent
   */
  resetFlow() {
    this.hfs.returnToPreviousFlow(
      // Trámite
      idTramite => this.selectedDefaultTramite(idTramite, 'tramiteInGoBack', true, false),
      // Microproceso
      idMicroProcess => this.runMicroProcess(idMicroProcess, true, false, false),
      this.idFlowactually,
      this.flowHistoryActually
    );
    this.flowHistoryActually = false;
  }

  /**
   * Destruye la template actual del flujo y la vuelve a cargar.
   * Esta función no debe usarse, solo es para casos desesperados
   * si se puede buscar el origen del problema que le impide que el flujo
   * actual no se actualize.
   *
   * @memberof ProcessAutomationComponent
   */
  forceRefreshFlow() {
    this.firstTemplate = null;
    setTimeout(() => {
      this.firstTemplate = this.flowConfigTpl;
      this.show.btnSync = true;
      this.closeTpl();
    });
  }

  /**
   * Reacciona al evento de soltar una tecla.
   *
   * @param {*} e
   * @memberof ProcessAutomationComponent
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(e: any) {
    switch (e.keyCode) {
      // Escape
      case 27:
        this.closeTpl(this.flowConfigTpl);
        break;
      // Ctrl
      // case 17:
      //   this.keyIsPressed.ctrl = false;
      //   break;
    }
  }

  /**
   * Reacciona al evento de presionar una tecla.
   *
   * @param {*} e
   * @memberof ProcessAutomationComponent
   */
  @HostListener('window:keydown', ['$event'])
  onKeyDown(e: any) {
    // switch (e.keyCode) {
    //   // Ctrl
    //   case 17:
    //     this.keyIsPressed.ctrl = true;
    //     break;
    // }
  }

  // --------- Selects categoria, proceso y trámite --------- >

  /**
   * Evento que se ejecuta cuando se selecciona una
   * acción (crear, editar, eliminar) para cualquier select
   * de categoria, proceso, trámite y proceso secundario.
   *
   * Nota: se usa la abreviación 'st' para referirse al
   * componente 'iw-select-tramite'.
   *
   * @param {EventAction} event
   * @memberof ProcessAutomationComponent
   */
  async stClickedAction(event: EventAction) {
    // Crear o editar
    if (event.action !== 'delete') {
      const ctx = this.cptFormCtx;
      let oldData: any = {};
      // Definir la plantilla para el create y edit
      this.firstTemplate = this.cptFormTpl;
      this.show.btnSync = false;
      // Setear propiedades del contexto de la plantilla
      ctx.event = event;
      ctx.classBtnSubmit = event.action === 'edit' ? 'btn-warning' : 'btn-success';
      ctx.valueBtnSubmit = event.action === 'edit' ? 'Editar' : 'Crear';
      // Consultar datos necesarios en el editar
      if (event.action === 'edit') {
        if (event.categoryAction !== 'secondaryProcess') {
          oldData = await this.sts.get(event.categoryAction, this.stcRef[event.categoryAction].id);
        } else {
          oldData = this.secondaryProcess;
        }
      }

      switch (event.categoryAction) {
        case 'category':
          ctx.controls = this.cptfs.getFieldsCategory(oldData);
          ctx.title = `${ctx.valueBtnSubmit} categoría`;
          break;
        case 'process':
          oldData['proceso_categoria'] = this.stcRef.category.id;
          ctx.controls = this.cptfs.getFieldsProcess(
            this.ngSelectFormulario,
            merge(oldData, {
              categories: this.stcRef.categories.map(v => {
                return { key: v.id, value: v.nombre };
              })
            })
          );
          ctx.title = `${ctx.valueBtnSubmit} proceso`;
          break;
        case 'tramite':
          const data = await this.sts.getDefaultStatusTramite();
          oldData['tramite_proceso'] = this.stcRef.process;
          ctx.controls = this.cptfs.getFieldsTramite(
            this.ngSelectFormulario,
            merge(oldData, {
              defaultStatusTramite: data.map(v => {
                return { key: v.id, value: v.nombre };
              }),
              processes: this.stcRef.processes.map(v => {
                return { key: v.id, value: v.nombre };
              })
            })
          );
          ctx.title = `${ctx.valueBtnSubmit} trámite`;
          break;
        case 'secondaryProcess':
          const dataStatusProcess = await this.sts.getDefaultStatusTramite();
          const dataStatusExpediente = await this.sts.getDefaultStatusExpediente();
          ctx.controls = this.cptfs.getFieldsSecondaryProcess(
            this.ngSelectFormulario,
            merge(oldData, {
              defaultStatusTramite: dataStatusProcess.map(v => {
                return { key: v.id, value: v.nombre };
              }),
              defaultStatusExpediente: dataStatusExpediente.map(v => {
                return { key: v.id, value: v.nombre };
              }),
              defaultRoles: this.mts.roles.map(v => {
                return { key: v.rol_id, value: v.nombre };
              }),
            })
          );
          ctx.title = `${ctx.valueBtnSubmit} proceso secundario`;
          ctx.extra = {secondaryProcess: this.secondaryProcess};
          break;
      }
    } else {
      // Eliminar
      this.confirmRef
        .new({
          question: '¿Esta seguro de continuar con la eliminación?',
          labelConfirm: 'si',
          labelDecline: 'no'
        })
        .then(async res => {
          if (res) {
            if (event.categoryAction !== 'secondaryProcess') {
              const deleted = await this.sts.delete(
                event.categoryAction, this.stcRef[event.categoryAction].id
              );
              if (deleted) {
                if (event.categoryAction === 'tramite') {
                  const removed = this.ss.removeLocalFlow(this.stcRef.tramite.id);
                  if (removed) {
                    this.configFlowTitle = null;
                  }
                }
                this.stcRef.reload(event.categoryAction);
              }
            } else {
              const deleted = await this.sts.delete(
                event.categoryAction, this.secondaryProcess.id
              );
              if (deleted) {
                this.secondaryProcess = null;
                this.reloadSeconary.emit(null);
              }
              log.debug(this.secondaryProcess);
            }
          }
        });
    }
  }

  /**
   * Recoge la información del formulario de creación y edición,
   * para categoría, proceso y trámite.
   * Nota: esto solo aplica para el crear y editar.
   *
   * @param {EventAction} event
   * @param {*} data
   * @memberof ProcessAutomationComponent
   */
  cptSended(event: EventAction, data: any) {
    const action = event.action === 'edit' ? 'modificación' : 'creación';
    this.confirmRef
      .new({
        question: `¿Esta seguro de continuar con la ${action}?`,
        labelConfirm: 'si',
        labelDecline: 'no'
      })
      .then(async res => {
        if (res) {
          this.cptFormCtx.isLoading = true;
          if (event.categoryAction === 'secondaryProcess') {
            if (!data['lista_etapas_tramite']) {
              data['lista_etapas_tramite'] = [];
            }
            if (!data['lista_estados_expediente']) {
              data['lista_estados_expediente'] = [];
            }
          }
          if (event.action === 'edit') {
            if (event.categoryAction !== 'secondaryProcess') {
              data['id'] = this.stcRef[event.categoryAction].id;
            } else {
              data['id'] = this.secondaryProcess.id;
              data['finalizacion_secundaria'] = this.completiosSecondary.completions;
              log.debug('finalizaciones secundaria', data['finalizacion_secundaria']);
              if (data['finalizacion_secundaria'] === false) {
                this.cptFormCtx.isLoading = false;
                this.toastr.warning(
                  'Verifique la información en la pestaña de finalizaciones',
                  'Información incompleta'
                );
                return;
              }
            }
          }
          try {
            const response = await this.sts.save(event, data);
            if (response) {
              if (event.categoryAction !== 'secondaryProcess') {
                if (event.action === 'create') {
                  await this.stcRef.reload(event.categoryAction, result(response, 'id'));
                } else {
                  await this.stcRef.reload(event.categoryAction, result(data, 'id'));
                }
              } else {
                this.reloadSeconary.emit(response.id ? response.id : null);
              }
              this.cptDyFormRef.reset();
              if (event.categoryAction === 'tramite' || event.categoryAction === 'secondaryProcess') {
                if (event.action === 'create') {
                  this.selectedDefaultTramite(response as TramiteBase);
                } else {
                  if (this.configFlowTitle && this.configFlowTitle.name) {
                    this.configFlowTitle.name = result(data, 'nombre');
                  }
                }
              } else if (event.categoryAction === 'process') {
                if (event.action === 'create') {
                  await this.stcRef.reload('tramite');
                }
              } else if (event.categoryAction === 'category') {
                if (event.action === 'create') {
                  await this.stcRef.reload('process');
                  this.stcRef.tramite = null;
                  this.stcRef.tramites = [];
                }
              }
              this.closeTpl();
            }
          } finally {
            this.cptFormCtx.isLoading = false;
          }
        }
      });
  }

  /**
   * Valida la información de los selects y guía el comportamiento
   * del usuario bloqueando y desapareciendo opciones.
   *
   * @param {Action} action
   * @returns {Partial<ConfigShowItems>}
   * @memberof ProcessAutomationComponent
   */
  cptShowItems(action: Action): Partial<ConfigShowItems> {
    const show: Partial<ConfigShowItems> = {};
    switch (action) {
      case 'create':
        show.process = !this.stcRef.category ? false : true;
        show.tramite = !this.stcRef.process ? false : true;
        break;
      case 'edit':
        show.category = !this.stcRef.category ? false : true;
        show.process = !this.stcRef.process ? false : true;
        show.tramite = !this.stcRef.tramite ? false : true;
        break;
      case 'delete':
        show.category = !this.stcRef.category || !isEmpty(this.stcRef.processes) ? false : true;
        show.process = !this.stcRef.process || !isEmpty(this.stcRef.tramites) ? false : true;
        show.tramite = !this.stcRef.tramite ? false : true;
        break;
    }
    return show;
  }

  // --------- Administrar flujo --------- >
  /**
   * Evento que se ejecuta al seleccionar un trámite por default.
   *
   * @param {(TramiteBase | number)} [tramiteBase]
   * @param {FlowType} [flowType='tramite']
   * @param {boolean} [goBack=false]
   * @param {boolean} [view=true]
   * @returns
   * @memberof ProcessAutomationComponent
   */
  async selectedDefaultTramite(
    tramiteBase?: TramiteBase | number,
    flowType: FlowType = 'tramite',
    goBack: boolean = false,
    view: boolean = true
  ) {
    let id: number;
    if (this.typeProcess === 'process') {
      if (!this.stcRef.generic) {
        id = <number>result(this.stcRef, 'tramite.id');
      } else {
        id = <number>result(this.stcRef, 'genericT.id');
      }
      this.origin = {
        category: <number>result(this.stcRef, 'category.id'),
        process: <number>result(this.stcRef, 'process.id'),
        tramite: id
      };
    } else {
      if (this.secondaryProcess && this.secondaryProcess.id) {
        id = this.secondaryProcess.id;
      }
      this.origin = {
        category: null,
        process: null,
        tramite: this.secondaryProcess ? this.secondaryProcess.id ? this.secondaryProcess.id : null : null
      };
    }
    // Definir el estado de sincronización del TRÁMITE
    let tramiteIsSynchronized = this.ss.getSynchronizationStatus('tramite');
    log.debug('tramiteIsSynchronized: ', tramiteIsSynchronized);

    // Cuando se abre el flujo para las etapas del trámite no se guardan cambios
    // no es necesario sacar los mensajes para descartar cambios
    if (this.flowMode != 'etapas') {
      // Confirmación de descartar cambios pendientes en el flujo
      if (
        !goBack && ((tramiteIsSynchronized || !this.mas.getRefineActivities().length) && this.ss.pendingChanges)
      ) {
        const res = await this.confirmRef
          .new({
            question: `¿Desea descartar los cambios realizados actualmente en el flujo?`,
            labelConfirm: 'si',
            labelDecline: 'no'
          });
        // Si hay cambios pendientes no se vuelve a consultar el flujo
        if (res) {
          // Descartar cambios pendientes
          this.ss.pendingChanges = false;
          this.ss.clearHistory();
        } else {
          return;
        }
      } else if (!goBack && (!tramiteIsSynchronized && this.mas.getRefineActivities().length)) {
        const res = await this.confirmRef
          .new({
            question: 'El flujo aun no ha sido sincronizado con la base de datos, ' +
              'al realizar esta acción puede perder los cambios realizados.' +
              '¿Desea continuar con la acción?',
            labelConfirm: 'si',
            labelDecline: 'no'
          });
        // Si hay cambios pendientes no se vuelve a consultar el flujo
        if (res) {
          // Descartar cambios pendientes
          this.ss.pendingChanges = false;
          this.ss.removeLocalFlow(this.hfs.flowsHistory[0]);
          this.ss.clearHistory();
        } else {
          return;
        }
      }
    }

    // Continuar proceso normalmente
    if (tramiteBase) {
      if (typeof tramiteBase === 'number') {
        id = tramiteBase;
        if (this.typeProcess === 'process') {
          if (!this.stcRef.generic) {
            this.stcRef.reload('tramite', id);
          } else {
            this.stcRef.reload('genericT', id);
          }
        } else {
          this.reloadSeconary.emit(id);
        }
      } else {
        id = tramiteBase.id;
        if (this.typeProcess === 'process') {
          if (!this.stcRef.generic) {
            this.stcRef.tramite = tramiteBase;
          } else {
            this.stcRef.genericT = tramiteBase;
  
          }
        } else {
          this.reloadSeconary.emit(id);
        }
      }
    }
    // const id = idTramite ? idTramite : this.stcRef.tramite.id;
    if (id) {
      let flow = null;
      // Consultar el flujo desde LocalStorage
      if (goBack) {
        flow = <Tramite>this.ss.getFromLocal([this.hfs.flowsHistory[0]], 1);
      }
      // Consultar flujo de DB
      if (!flow) {
        this.isLoading.flow = true;
        if (this.typeProcess === 'process') {
          flow = await this.pas.getDefaultTramite(id);
        } else {
          flow = await this.pas.getDefaultSecondaryProcess(id);
        }
        this.isLoading.flow = false;
      }
      // Almacenar y mostrar flujo
      this.setFlow(flowType, flow, this.origin, false, true);
      // validar si el flujo no esta sincronizado y tiene tareas por guardar
      tramiteIsSynchronized = this.ss.getSynchronizationStatus('tramite');
      if ((!tramiteIsSynchronized && this.mas.getRefineActivities().length)) {
        this.ss.pendingChanges = true;
      }
      // Definir template para la vista principal
      if (view) {
        if (this.flowMode === 'normal') {
          this.firstTemplate = this.flowConfigTpl;
          this.show.btnSync = true;
        } else {
          this.secondTemplate = this.flowConfigTpl;
        }
      }

    } else {
      log.error('Es necesario el id del trámite por default.');
    }
  }

  /**
   * Evento que se ejecuta al entrar a un microproceso por default.
   *
   * @param {(Tarea | number)} task
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [view=true]
   * @memberof ProcessAutomationComponent
   */
  async runMicroProcess(
    task: Tarea | number,
    goBack: boolean = false,
    clean: boolean = false,
    view: boolean = true
  ) {
    const idTask = typeof task === 'number' ? task : task.id;
    if (this.typeProcess === 'process') {
      this.origin = {
        category: <number>result(this.stcRef, 'category.id'),
        process: <number>result(this.stcRef, 'process.id'),
        tramite: <number>result(this.stcRef, 'tramite.id')
      };
    } else {
      this.origin = {
        category: null,
        process: null,
        tramite: this.secondaryProcess.id
      };
    }
    let flow;
    // Validación: la tarea debe ser de tipo micro proceso
    if (typeof task !== 'number' && task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
      log.debug(`No se puede tratar la tarea de tipo ${task.tarea_tipo.nombre} como un microproceso.`);
    }

    // Por defecto se consulta el microproceso guardado en el LocalStorage
    flow = <Microproceso>this.ss.getMicroProcess([idTask], true);

    // Si el microproceso existe en la DB
    if (idTask > 0) {
      // Si no se ha consultado el flujo por primera vez
      if (!(flow && flow.id === idTask)) {
        // Consultar flujo de DB
        this.isLoading.flow = true;
        if (this.typeProcess === 'process') {
          flow = await this.pas.getDefaultMicroProces(idTask);
        } else if (this.typeProcess === 'secondary_process') {
          flow = await this.pas.getDefaultSecondaryMicroProces(idTask);
        }
        this.isLoading.flow = false;
      }
    } else {
      // Establece que el flujo no esta sincronizado
      if (!flow) {
        // Crear microproceso en local
        flow = new Microproceso({
          id: idTask,
          descripcion: (<Tarea>task).nombre,
          tarea_estado: (<Tarea>task).tarea_estado,
          orden: (<Tarea>task).orden
        });
      }
    }
    // Almacenar y mostrar flujo
    this.setFlow('microproces', flow, this.origin, goBack, clean);
    // Definir template para la vista principal
    if (view) {
      if (this.flowMode === 'normal') {
        this.firstTemplate = this.flowConfigTpl;
        this.show.btnSync = true;
      } else {
        this.secondTemplate = this.flowConfigTpl;
      }
    }
  }

  /**
   * Setea los datos usados para generar el flujo.
   *
   * @param {(Tramite | Microproceso)} flowDB
   * @param {boolean} [goBack=false] - Define si se esta ascendiendo de un microproceso.
   * @param {boolean} [clean=false] - Resetea el historial de flujo, y define el nivel 1.
   * @memberof ProcessAutomationComponent
   */
  setFlow(
    flowType: FlowType,
    flow: Tramite | Microproceso,
    origin: FlowOrigin,
    goBack: boolean = false,
    clean: boolean = false
  ) {
    if (this.flowMode === 'normal') {
      this.toggleCompletionMode(false);
    } else {
      this.toggleCompletionMode(true, this.flowMode);
    }
    // Registrar el nivel del flujo
    // Nota: el nivel define si estoy parado o no en un microproceso
    this.hfs.updateFlowHistory(flow, goBack, clean);
    // Almacenar flujo en memoria
    this.ss.setFlow(flowType, flow, origin);
    // Configurar propiedades para generar el título del flujo
    this.configFlowTitle = merge(this.hfs.getFlowTitle(flow), {
      notSynchronized: !this.ss.isSynchronized
    });
  }

  // --------- Administrar actividades --------- >

  /**
   * Controla y ejecuta una acción definida para una actividad.
   *
   * @param {actionManage} event
   * @param {*} [data]
   * @memberof ProcessAutomationComponent
   */
  initManageActivity(event: actionManage, data?: any) {
    // Contexto(conjunto de propiedades) usadas en la plantilla para crear y editar
    const ctx = this.manageActivityCtx;
    // Eliminar actividad si se realiza la combinación ctrl + clic, sin confirmación
    if (event === 'edit' && this.keyIsPressed.ctrl) {
      this.removeObjectFlow(data.activity, 'activity', true);
    } else if (event === 'remove') {
      // Eliminar actividad, con confirmación
      this.removeObjectFlow(data.activity, 'activity');
    } else {
      // Definir información extra que pueda llegar a ser útil en la template
      ctx.extra = data;
      ctx.isLoading = true;
      // Lista de opciones compatibles para el select de estado
      const statusOptions = this.mas.getStatusOptions();
      // Definir propiedades para configurar el formulario dinámico
      const defaultData = {
        statusOptions: statusOptions
      };
      const configControls = !data ? defaultData : merge(data.activity, defaultData);
      ctx.controls = this.mas.getControlsForDynamicForm(configControls);
      ctx.title = event === 'edit' ? 'Editar' : 'Crear';
      ctx.valueBtnSubmit = ctx.title;
      ctx.classBtnSubmit = event === 'edit' ? 'btn-warning' : 'btn-success';
      ctx.event = event;
      ctx.isLoading = false;
      // Definir plantilla encargada de mostrar el formulario
      this.firstTemplate = this.manageActivityTpl;
      this.show.btnSync = false;
    }
  }

  /**
   * Recoge la información del formulario de creación y edición,
   * de actividades.
   *
   * @param {('edit' | 'create')} action
   * @param {*} data
   * @memberof ProcessAutomationComponent
   */
  sendedActivity(event: actionManage, data: any) {
    const ctx = this.manageActivityCtx;
    // Remplazar el id del estado por su objeto
    const status = find(this.mas.status, {
      id: Number(data.actividad_estado)
    });
    data.actividad_estado = status;
    // Determinar evento a realizar
    switch (event) {
      case 'create':
        // Validar si se quiere crear la actividad en un orden específico
        const existsNextOrder = !isEmpty(ctx.extra) && ctx.extra.hasOwnProperty('nextOrderCreateActivity');
        let order = existsNextOrder ? ctx.extra.nextOrderCreateActivity : 0;
        if (this.counterCreationActivities > 0 && order > 0) {
          order += this.counterCreationActivities;
        }
        // Crear nueva actividad
        this.mas.new(data, order);
        this.counterCreationActivities++;
        this.ss.pendingChanges = true;
        break;
      case 'edit':
        const mergeJSON = require('locutus/php/array/array_merge');
        const oldActivity = Object.assign({}, ctx.extra.activity);
        const activity = mergeJSON(oldActivity, data);
        // Eliminar datos innecesarios de la actividad
        delete activity['statusActivityOptions'];
        const edited = this.mas.edit(activity);
        // Si se edita la actividad exitosamente
        if (edited) {
          this.closeTpl();
        }
        break;
    }
  }

  /**
   * Consulta si la forma seleccionada para la tarea tiene listas de cheque que puedan ser configurdas
   *
   * @param {number} idForm
   * @memberof ProcessAutomationComponent
   */
  loadFormCheckList(idForm: number) {
    if (idForm) {
      this.pas.getFormCheckList(idForm).subscribe(form => {
        if (Object.keys(form).length) {
          this.formCheckList = true;
          this.formsCheckListSelected = form;
          if (idForm === this.manageTaskCtx.extra.task.tarea_forma[0].id_forma) {
            if (this.manageTaskCtx.extra.task.tarea_forma[0].opciones) {
              this.optionsFormSelect = this.manageTaskCtx.extra.task.tarea_forma[0].opciones;
            } else {
              this.optionsFormSelect = {};
            }
          } else {
            this.optionsFormSelect = {};
          }
          if (this.manageChecklistFormRef) {
            this.manageChecklistFormRef.formsCheckList = form;
            this.manageChecklistFormRef.refresh();
          }
        } else {
          this.formCheckList = false;
          this.formsCheckListSelected = undefined;
        }
      });
    } else {
      this.formCheckList = false;
      this.formsCheckListSelected = undefined;
    }
  }

  /**
   * Controla y ejecuta una acción definida para una tarea.
   * Si la tarea es un microproceso lo ejecuta.
   *
   * @param {actionManage} event
   * @param {*} [data]
   * @memberof ProcessAutomationComponent
   */
  initManageTask(event: actionManage, data?: any) {
    // Contexto(conjunto de propiedades) usadas en la plantilla para crear y editar
    const ctx = this.manageTaskCtx;
    const task: Tarea = data.task;
    const sharedData = data.sharedData ? data.sharedData : null;
    let activity: Actividad = data.activity;

    // Si hay una tarea pero no la actividad a la que pertenece
    if (task && !activity) {
      // Filtrar actividad de flujo local
      activity = find(this.mas.activities, { id: task.meta.idActivity });
    }
    // Eliminar tarea si se realiza la combinación ctrl + clic, sin confirmación
    if (this.flowMode === 'normal' && event === 'edit' && this.keyIsPressed.ctrl) {
      this.removeObjectFlow({ activity: activity, task: task } as ActivityTask, 'task', true);
    } else if (event === 'remove') {
      // Eliminar tarea, con confirmación
      this.removeObjectFlow({ activity: activity, task: task } as ActivityTask, 'task');
    } else if (event === 'create' || event === 'edit') {
      if (this.flowMode === 'normal') {
        // Definir información extra que pueda llegar a ser útil en la template
        ctx.extra = Static.copyObjet(
          data,
          [
            'asignationRoles',
            'responsibleRoles',
            'selectRolesTpl',
            'statusOptions',
            'typesOptions'
          ]
        );
        ctx.isLoading = true;
        // Lista de opciones compatibles para el select de tipo tarea
        const typesOptions = this.mts.getTypesOptions();
        // Lista de opciones compatibles para el select de estado tarea
        const statusOptions = this.mts.getStatusOptions();
        // Definir propiedades para configurar el formulario dinámico
        let defaultData = {
          typesOptions: typesOptions,
          statusOptions: statusOptions,
          selectRolesTpl: this.selectRolesTpl
        };
        // Definir información importante para el editar
        if (event === 'edit') {
          ctx.extra.activity = activity;
          const roles = this.mts.destructureRoles(task.tarea_rol);
          defaultData = merge(defaultData, {
            asignationRoles: roles.assigned,
            responsibleRoles: roles.responsibles
          });
          if (task.tarea_forma && task.tarea_forma.length) {
            this.loadFormCheckList(task.tarea_forma[0].id_forma);
          }
        }
        const configControls = !data ? defaultData : merge(task, defaultData);
        // Generar controles del formulario
        ctx.controls = this.mts.getControlsForDynamicForm(configControls);
        // Definir variables de configuración de la plantilla
        ctx.title = event === 'edit' ? 'Editar' : 'Crear';
        ctx.valueBtnSubmit = ctx.title;
        ctx.classBtnSubmit = event === 'edit' ? 'btn-warning' : 'btn-success';
        ctx.event = event;
        ctx.isLoading = false;
        // Definir plantilla encargada de mostrar el formulario
        this.firstTemplate = this.manageTaskTpl;
        this.show.btnSync = false;
        if(this.manageTaskCtx && this.manageTaskCtx.extra && this.manageTaskCtx.extra.task && 
          this.manageTaskCtx.extra.task.tarea_forma && this.manageTaskCtx.extra.task.tarea_forma.length
           && this.manageTaskCtx.extra.task.tarea_forma[0].parametros && this.manageTaskCtx.extra.task.tarea_forma[0].parametros["asociar"]){
          this.formRestrition = true;
        }else{
          this.formRestrition = false;
        }
      } else if (this.flowMode === 'completion') {
        // Guardar tarea de destino para la finalización
        this.updateCompletion(task);
      } else if (this.flowMode === 'association') {
        let taskA: Tarea = {} as Tarea;
        taskA = merge(taskA, task);
        // Guardar tarea de asociacion para la finalización
        this.updateAssociations(taskA, sharedData);
      }
    } else if (event === 'run') {
      if (this.flowMode !== 'association' &&
        (
          this.typeProcess === 'process' ||
          this.typeProcess === 'secondary_process'
        )
      ) {
        // Ejecutar microproceso
        this.runMicroProcess(task);
      }
    }
  }

  /**
   * Notificar tarea de finalización al administrador de finalizaciones
   *
   * @private
   * @param {Tarea} taskTarget
   * @memberof ProcessAutomationComponent
   */
  private updateCompletion(taskTarget: Tarea) {
    if (taskTarget.tarea_tipo && taskTarget.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
      this.ns.set({
        source: 'processAutomation',
        eventTriggered: 'click',
        action: 'setTaskTarget',
        instance: this.typeProcess,
        data: <NotifyCompletion>{
          id: this.manageCompletionId,
          targetTask: taskTarget
        }
      });
      // Salir del modo de finalización
      this.resetFlow();
      this.toggleCompletionMode(false);
    } else {
      this.runMicroProcess(taskTarget);
    }
  }

  /**
   * Valida que la tarea no se encuentre ya asociada y notifica la asociacion
   *
   * @private
   * @param {Tarea} taskTarget
   * @memberof ProcessAutomationComponent
   */
  private updateAssociations(taskTarget: Tarea, sharedData?: any) {
    if (taskTarget.tarea_tipo && taskTarget.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
      if (sharedData) {
        if (sharedData['nombre']) {
          taskTarget.descripcion = 'Trámite: ' + sharedData['nombre'];
          taskTarget['tramite'] = sharedData['nombre'];
        }
        if (sharedData['proceso_externo']) {
          taskTarget['proceso_externo'] = sharedData['proceso_externo'];
        }
      }
      if (!result(taskTarget.meta, 'indexFlow')) {
        taskTarget.meta['indexFlow'] = taskTarget.orden;
      }
      const existTaskAssociation = find(this.taskAssociation, {id: taskTarget.id});
      if (!existTaskAssociation) {
        // Notificar tarea de asociacion al administrador de asociaciones
        this.taskAssociation.push(taskTarget);
        this.ns.set({
          source: 'processAutomation',
          eventTriggered: 'click',
          action: 'setTaskTarget',
          instance: this.typeProcess,
          data: <NotifyAssociation>{
            id: this.manageCompletionId,
            targetTask: this.taskAssociation
          }
        });
        // Salir del modo de finalización
        delete this.taskAssociation;
        this.toggleCompletionMode(false);
        this.resetFlow();
      } else {
        this.toastr.error('La tarea ya se encuentra asociada', 'Error en formas');
      }
    } else {
      this.runMicroProcess(taskTarget);
    }
  }

  /**
   * Recoge la información del formulario de creación y edición,
   * de tareas.
   *
   * @param {('edit' | 'create')} action
   * @param {*} data
   * @memberof ProcessAutomationComponent
   */
  sendedTask(event: actionManage, data: any) {
    // Crear copia del obj de los datos
    const copyData = Object.assign({}, data);
    copyData.tarea_finalizacion = [];
    // Contexto de la plantilla
    const ctx = this.manageTaskCtx;
    // Autoriza resetear el formulario principal
    let authorizeReset = false;

    // Remplazar el id del tipo por su objeto
    copyData.tarea_tipo = this.convetTypeTask(copyData.tarea_tipo);
    // Remplazar el id del estado por su objeto
    copyData.tarea_estado = find(this.mts.status, {
      id: Number(copyData.tarea_estado)
    });

    let formCondition = false;
    // Validar si es tipo forma para guardarla
    if ((<TareaTipo>copyData.tarea_tipo).nombre === Const.TYPES_TASK.form) {
      const form: NotifyTareaForma = this.manageFormRef.getForm();
      if (!form) {
        return;
      }
      copyData.tarea_forma = [{
        id_forma: form.id_forma,
        nombre: form.nombre,
        parametros: form.parametros,
        condicion: this.formCondiction
      }];

      if (this.formCheckList) {
        copyData.tarea_forma[0]['opciones'] = this.manageChecklistFormRef.getSpecificRecords();
      }

      formCondition = form.condicion;
    }

    // Agregar condiciones, si se configurarón correctamente
    if (
      (<TareaTipo>copyData.tarea_tipo).nombre === Const.TYPES_TASK.condition ||
      (this.formCondiction && (<TareaTipo>copyData.tarea_tipo).nombre === Const.TYPES_TASK.form)
    ) {
      const conditions = <TareaCondicionAdmin[]>this.manageConditionsRef.getData();
      const isValid = this.manageConditionsRef.isValidData();
      if (!isEmpty(conditions) && isValid) {
        const completions = this.manageConditionsRef.getCompletions();
        // Agregar las finalizaciones
        conditions.forEach((condition, index) => {
          condition.opciones.sort((a, b) => a.orden - b.orden);
          condition.opciones.map((opt, i) => {
            completions[index].forEach(completion => {
              if (completion.opcion === opt.id_opcion) {
                copyData.tarea_finalizacion.push(completion);
              }
            });
          });
        });
        copyData.tarea_condicion = conditions;
      } else {
        log.debug('Error: al agregar las condiciones.');
        this.toastr.warning('Por favor verifique la información de condiciones', 'Error en condiciones');
        return;
      }
    } else {
      if (!formCondition && (<TareaTipo>copyData.tarea_tipo).nombre !== Const.TYPES_TASK.microProcess) {
        // Agregar finalización, si se configuró correctamente
        const isValid = this.manageCompletionRef.isValidData();
        if (
          this.manageCompletionRef &&
          isValid
        ) {
          // Crear finalizaciones
          const completions = this.manageCompletionRef.getCompletion();
          if (completions && completions.length) {
            completions.map(completion => {
              if (!completion.opcion) {
                completion.opcion = 0;
              }
            });
          }
          copyData.tarea_finalizacion = completions;
        } else {
          log.debug('Error: al agregar las finalizaciones.');
          this.toastr.warning('Por favor verifique la información de la finalización',
            'Error en finalizaciones');
          return;
        }
      }
    }

    if ((<TareaTipo>copyData.tarea_tipo).nombre !== Const.TYPES_TASK.microProcess) {
      // Generar array de roles que pueden asignar y/o ser responsbles
      copyData.tarea_rol = this.mts.generateRoleFormat(copyData.asignationRoles, copyData.responsibleRoles);
      // Consultar documentos de la tarea
      copyData.documentos = this.manageDocumentRef.getDocument();
      // consultar tareas asociadas
      copyData.tarea_asociacion = this.manageAssociationsRef.getAsocciations();
      if (copyData.tarea_asociacion === 'tipo') {
        this.toastr.warning('Debe seleccionar el tipo de asociación para todas las tareas', 'Error en asociaciones');
        return;
      } else if (copyData.tarea_asociacion === 'alias') {
        this.toastr.warning('Caracteres invalidos para los alias de las asociaciones', 'Error en asociaciones');
        return;
      } else if (copyData.tarea_asociacion === 'duplicacion') {
        this.toastr.warning('Duplicación de alias en las asociaciones', 'Error en asociaciones');
        return;
      }
    } else {
      copyData.tarea_rol = [];
    }
    // Eliminar key innecesarias
    delete copyData.asignationRoles;
    delete copyData.responsibleRoles;
    if (copyData.rechazable === null || copyData.rechazable === undefined) {
      copyData.rechazable = false;
    }
    // Determinar evento a realizar
    switch (event) {
      case 'create':
        // Crear nueva tarea
        this.mts.new(ctx.extra.activity, copyData);
        authorizeReset = true;
        this.ss.pendingChanges = true;
        break;
      case 'edit':
        const copyTask = Object.assign({}, ctx.extra.task);
        // Limpiar Data conformato de la consulta del flujo
        copyTask.tarea_forma = [];
        copyTask.tarea_condicion = [];
        copyTask.documentos = [];
        copyTask.tarea_asociacion = [];
        copyTask.tarea_rol = [];
        copyTask.tarea_finalizacion = [];
        const edited = this.updateTask(ctx.extra.activity, merge(copyTask, copyData));
        // Si se edita la tarea exitosamente
        if (edited) {
          authorizeReset = true;
          this.forceRefreshFlow();
        } else {
          log.debug(`Error: No se pudó editar la tarea: ${edited}`);
        }
        break;
    }
    if (authorizeReset) {
      // Resetear formularios
      if ((<TareaTipo>copyData.tarea_tipo).nombre !== Const.TYPES_TASK.microProcess) {
        this.manageAssociationsRef.empty();
        this.manageDocumentRef.empty();
        if ((<TareaTipo>copyData.tarea_tipo).nombre === Const.TYPES_TASK.form) {
          this.manageFormRef.empty();
        }
        if ((<TareaTipo>copyData.tarea_tipo).nombre === Const.TYPES_TASK.condition || this.formCondiction) {
          // Resetear componente que controla las condiciones
          this.manageConditionsRef.reset();
        } else {
          this.manageCompletionRef.empty();
        }
      }
      this.taskDyFormRef.reset();
    }
  }

  addConditions(data: TareaCondicionAdmin) {
    const ctx = this.manageTaskCtx;
    this.updateTask(ctx.extra.activity, merge(ctx.extra.task, data));
  }

  convetTypeTask(id: string) {
    return find(this.mts.types, {
      id: Number(id)
    });
  }

  /**
   * Realiza una copia de segurida en memoria de los datos deseados.
   * Los datos se almacenan en un objeto, cada key corresponde a un backup.
   *
   *
   * @param {string} key
   * @param {*} [data]
   * @param {Function} [restore=null] - callback que controla donde restablecer los datos.
   * @memberof ProcessAutomationComponent
   */
  backup(key: string | string[], data?: any, restore?: (backup: any) => void, removeAfterRestore: boolean = false) {
    const set = (k: string, d: any) => {
      if (!this.dataBackup.hasOwnProperty(k)) {
        this.dataBackup[k] = d;
      } else {
        log.debug(`No se puede volver almacenar un backup con la misma key(${k}).`);
      }
    };
    const get = (k: string): any => {
      if (this.dataBackup.hasOwnProperty(k)) {
        return this.dataBackup[k];
      } else {
        log.debug(`No existe un backup con la key ==> ${k}`);
      }
    };
    const remove = (k: string) => {
      if (this.dataBackup.hasOwnProperty(k)) {
        delete this.dataBackup[k];
      } else {
        log.debug(`No existe un backup con la key(${k}).`);
      }
    };

    if (!restore && data) {
      if (typeof key === 'string') {
        set(key, data);
      } else {
        key.forEach((el, i) => {
          set(el, data[i]);
        });
      }
    } else if (restore) {
      if (typeof key === 'string') {
        restore(get(key));
        if (removeAfterRestore) {
          remove(key);
        }
      } else {
        const res: any[] = [];
        key.forEach(el => {
          res.push(get(el));
          if (removeAfterRestore) {
            remove(el);
          }
        });
        restore(res);
      }
    } else {
      if (typeof key === 'string') {
        remove(key);
      } else {
        key.forEach(el => {
          remove(el);
        });
      }
    }
  }

  /**
   * Se encarga de abrir el flujo del tramite en determinado modo del flujo.
   *
   * @param {boolean} active
   * @param {FlowMode} [flowMode='completion']
   * @memberof ProcessAutomationComponent
   */
  toggleCompletionMode(active: boolean, flowMode: FlowMode = 'completion') {
    if (active) {
      this.flowMode = flowMode;
      if (this.flowMode === 'association') {
        this.secondTemplate = this.flowAssociationsTpl;
        // Configurar propiedades para generar el título del flujo
        this.configFlowTitleTemporalAsociation = this.hfs.getFlowTitle(this.ss.flow);
      } else {
        this.secondTemplate = this.flowConfigTpl;
      }
      this.show.firstTemplate = false;
      this.show.secondTemplate = true;
    } else {
      this.flowMode = 'normal';
      this.secondTemplate = null;
      this.show.firstTemplate = true;
      this.show.secondTemplate = false;
    }
  }

  /**
   * Actualiza la tarea dentro de la actividad correspondiente
   *
   * @param {Actividad} activity
   * @param {Tarea} task
   * @returns {boolean}
   * @memberof ProcessAutomationComponent
   */
  updateTask(activity: Actividad, task: Tarea): boolean {
    const edited = this.mts.edit(activity, task);
    // Si se edita la tarea exitosamente
    if (edited) {
      this.toastr.success(`Tarea actualizada correctamente.`);
      return true;
    }
    return false;
  }

  /**
   * Elimina un elemento del flujo con o sin confirmación.
   *
   * @param {RemovedObject} obj
   * @param {RemovedObjectType} type
   * @param {boolean} [direct=false]
   * @memberof ProcessAutomationComponent
   */
  removeObjectFlow(obj: RemovedObject, type: RemovedObjectType, direct: boolean = false) {
    const id = type === 'task' ? (obj as ActivityTask).task.id : (obj = obj as Actividad).id;
    const name = type === 'task' ? (obj as ActivityTask).task.nombre : (obj = obj as Actividad).nombre;
    const remove = () => {
      let res = false;
      if (type === 'task') {
        obj = obj as ActivityTask;
        res = this.mts.remove(obj.activity, obj.task);
      } else {
        obj = obj as Actividad;
        res = this.mas.remove(obj, this.origin);
      }
      if (res) {
        this.forceRefreshFlow();
      }
    };

    if (!direct) {
      const nameObj = type === 'task' ? 'tarea' : 'actividad';
      this.confirmRef
        .new({
          question: `¿Esta seguro de eliminar la ${nameObj} con el id: ${id} y nombre: ${name}?`,
          labelConfirm: 'si',
          labelDecline: 'no'
        })
        .then(res => {
          if (res) {
            remove();
          }
        });
    } else {
      // Elimina el elemento sin pedir confirmación
      remove();
    }
  }

  /**
   * Evento soltar Dragula.
   *
   * @private
   * @param {any} args
   * @memberof ProcessAutomationComponent
   */
  private onDropModel(args: any[]) {
    const [bagName, el, target, source] = args;

    // Si es la bolsa de actividades
    if (bagName === 'bag-activities') {
      this.mas.reorderWithIndex(this.mas.activities);
      this.mas.saveInLocal();
      const isLocalElement = (element: Actividad | Tarea): boolean => {
        if (element.id < 0) {
          return true;
        }
        return false;
      };
      if (this.ss.isSynchronized) {
        this.mas.activities.map((element) => {
          if (!isLocalElement(element)) {
            const activityInHistory = this.ss.getActionHistory('activities', 'update', element.id);
            if (activityInHistory) {
              this.ss.removeActionHistory('activities', 'update', element.id);
            }
            this.ss.addActionHistory('activities', 'update', { activityId: element.id });
          }
        });
      }
    }
    // Si es la bolsa de tareas
    if (bagName === 'bag-tasks') {
      // Data transferida del los elementos
      const data = {
        indexActivity: Number(el.dataset.indexactivity),
        indexTask: Number(el.dataset.indextask),
        idTask: Number(el.dataset.idtask),
        targetIndexActivity: Number(target.dataset.indexactivity)
      };
      // Consultar actividad y tarea actuales
      const current = this.mts.getTaskWithIndex(data.indexActivity, data.indexTask);
      // Consultar actividad de destino
      const activityTarget = this.mas.activities[data.targetIndexActivity];
      // Si la actividad de destino es diferente a la actual
      if (activityTarget.id !== current.activity.id) {
        // Si la tarea no se encuentra en la actividad de origen se busca en la de destino
        if (!current.task && data.idTask) {
          current.task = find(activityTarget.tareas, {id: data.idTask});
        }
        if (current.task) {
          // Cambiar la tarea a la actividad de destino
          const indexTask = findIndex(activityTarget.tareas, {id: data.idTask});
          if (indexTask !== -1) {
            activityTarget.tareas[indexTask].tarea_actividad = activityTarget.id;
            activityTarget.tareas[indexTask].orden = indexTask + 1;
          }
          // Reordenar tareas de la actividad de destino
          this.mts.reorderWithIndex(activityTarget.tareas);
          // guardar las modificaciones de las tareas
          if (activityTarget.tareas && activityTarget.tareas.length) {
            activityTarget.tareas.forEach(taskA => {
              this.mts.edit(activityTarget, taskA);
            });
          }
          this.mts.saveInLocal(activityTarget);
        }
      }
      // Reordenar tareas de la actividad actual
      if (current.activity.tareas.length) {
        this.mts.reorderWithIndex(current.activity.tareas);
        if (current.activity.tareas && current.activity.tareas.length) {
          current.activity.tareas.forEach(taskA => {
            this.mts.edit(current.activity, taskA);
          });
        }
        this.mts.saveInLocal(current.activity);
      }
    }
  }

  /**
   * Sincroniza el flujo de LocalStorage en la Base de Datos.
   *
   * @memberof ProcessAutomationComponent
   */
  async sync() {
    this.isLoading.sync = true;
    const res = await this.ss.syncInDB();
    this.isLoading.sync = false;
    if (res) {
      this.selectedDefaultTramite();
    }
  }

  /**
   * Permite usar la función 'result' de lodash en la vista.
   *
   * @param {Object} obj
   * @param {string} _find
   * @returns {*}
   * @memberof ProcessAutomationComponent
   */
  result(obj: Object, _find: string): any {
    return result(obj, _find);
  }

  /**
   * Controla el cambio del tipo de tarea
   *
   * @param {*} data
   * @memberof ProcessAutomationComponent
   */
  changeTypeTask(data: any) {
    if (data.change && this.manageTaskCtx && this.manageTaskCtx.extra && this.manageTaskCtx.extra.task) {
        if (data.change['tarea_tipo'] !== this.typeTaskOld) {
          // Limpiar Data conformato de la consulta del flujo
          if (this.mts.isType(data.change['tarea_tipo'], 'microProcess')) {
            this.manageTaskCtx.extra.task.tarea_forma = [];
            this.manageTaskCtx.extra.task.tarea_condicion = [];
            this.manageTaskCtx.extra.task.documentos = [];
            this.manageTaskCtx.extra.task.tarea_asociacion = [];
            this.manageTaskCtx.extra.task.tarea_finalizacion = [];
          } else if (
            !this.mts.isType(data.change['tarea_tipo'], 'form') &&
            (
              this.formCondiction ||
              this.formCheckList
            )
          ) {
            this.formCondiction = false;
            this.formCheckList = false;
            this.optionsFormSelect = {};
            this.manageTaskCtx.extra.task.tarea_forma = [];
            this.manageTaskCtx.extra.task.tarea_condicion = [];
            this.manageTaskCtx.extra.task.tarea_finalizacion = [];
          } else if (!this.mts.isType(data.change['tarea_tipo'], 'condition')) {
            if (
              this.manageTaskCtx.extra.task &&
              this.manageTaskCtx.extra.task.tarea_condicion &&
              this.manageTaskCtx.extra.task.tarea_condicion.length
            ) {
              this.manageTaskCtx.extra.task.tarea_condicion = [];
              this.manageTaskCtx.extra.task.tarea_finalizacion = [];
            }
          } else if (this.mts.isType(data.change['tarea_tipo'], 'condition')) {
            this.manageTaskCtx.extra.task.tarea_condicion = [];
            this.manageTaskCtx.extra.task.tarea_finalizacion = [];
          }
        }
      this.typeTaskOld = data.change['tarea_tipo'];
    }
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/process-automation.component.ts